import { createProtocolClient } from "@snowiespace/protocol";

export const client = createProtocolClient();
